<mat-card appearance="outlined" class="" fxLayout="column">
    <div fxLayout="row" fxFlex="100">
        <div fxFlex="70">
            <p class="pt-4 dark-color-80 subtitle-1-bold pb-8">
                {{ "APP_CASES.LINKED_JAROWA_CASES" | translate }}
            </p>
        </div>
    </div>

    <div fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="column" fxFlex="100" class="">
            <div fxLayout="column" class="">
                <div fxLayout="row" fxLayoutAlign="start center" class="cursor-pointer" id="am-1057">
                    <div>
                        <mat-icon class="font-size-12 badge-yellow mt-4 mr-4" color="yellow">lens</mat-icon>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <a class="badge-green" href="{{ getJarowaWorkorderUrl() }}" target="_blank">{{
                            jarowaWorkorderInfo?.CaseClaimNumber
                        }}</a>

                        <a *ngIf="jarowaWorkorderInfo?.WorkorderId && isSystemAdminOrAdmin"
                           (click)="navigateToYarowaCockpit($event)"
                           matTooltip="Open in Yarowa Cockpit"
                           class="ml-8 cursor-pointer text-secondary flex-align-center">
                            <mat-icon class="font-size-18" style="height: 18px; width: 18px; line-height: 18px; color: #00A780;">open_in_new</mat-icon>
                        </a>
                    </div>
                </div>
            </div>
            <div *ngIf="!jarowaWorkorderInfo || !jarowaWorkorderInfo.CaseClaimNumber">
                <p class="">{{ "NO_DATA_FOUND" | translate }}</p>
            </div>
        </div>
    </div>
</mat-card>
